document.addEventListener('DOMContentLoaded', function() {
  const toggleBtn = document.querySelector('.mobile-menu-toggle');
  const header = document.getElementById('main-header');
  const closeBtn = document.querySelector('.mobile-close-btn');
  
  if (toggleBtn && header) {
    toggleBtn.addEventListener('click', function() {
      if (header.classList.contains('mobile-menu-open')) {
        // Tutup menu
        header.classList.remove('mobile-menu-open');
        document.body.classList.remove('mobile-menu-open');
        toggleBtn.setAttribute('aria-expanded', 'false');
      } else {
        // Buka menu
        header.classList.add('mobile-menu-open');
        document.body.classList.add('mobile-menu-open');
        toggleBtn.setAttribute('aria-expanded', 'true');
      }
    });
  }
  
  // Close button handler
  if (closeBtn && header) {
    closeBtn.addEventListener('click', function() {
      header.classList.remove('mobile-menu-open');
      document.body.classList.remove('mobile-menu-open');
      toggleBtn.setAttribute('aria-expanded', 'false');
    });
  }
  
  // Tutup menu saat klik di luar menu
  document.addEventListener('click', function(event) {
    const navLinks = document.querySelector('.nav-links');
    
    // Cek apakah klik di luar header
    if (!header.contains(event.target) && header.classList.contains('mobile-menu-open')) {
      header.classList.remove('mobile-menu-open');
      document.body.classList.remove('mobile-menu-open');
      toggleBtn.setAttribute('aria-expanded', 'false');
    }
  });
  
  // Tutup menu saat tombol ESC ditekan
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape' && header.classList.contains('mobile-menu-open')) {
      header.classList.remove('mobile-menu-open');
      document.body.classList.remove('mobile-menu-open');
      toggleBtn.setAttribute('aria-expanded', 'false');
    }
  });
});
